import React from "react";

const ServiceCard = ({ icon, title, content }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col h-full transition-all duration-300 hover:border-t-4 hover:border-primary cursor-pointer">
      <div className="flex items-center gap-3 mb-4">
        <div className="text-primary group-hover:text-primary-dark transition-colors duration-300 flex-shrink-0">
          {icon}
        </div>
        <h3 className="text-black font-semibold text-xl group-hover:text-primary transition-colors duration-300">
          {title}
        </h3>
      </div>
      <p className="text-black text-sm leading-relaxed flex-grow">{content}</p>
    </div>
  );
};

export default ServiceCard;
